// @flow
import { EnsembleList } from '../schema';
import { loadedCursor } from '../middleware/apiCacheValidators';
import { normalizeMetaList } from '../schema/normalizeMeta';

import type { Request } from './types';

export type LoadEnsemblesAction = { type: 'FETCH_ENSEMBLES' } & Request;

export type EnsembleAction = LoadEnsemblesAction;

export function loadEnsembles(
  cursor: string,
  name?: string = '',
  limit: number = 50
): LoadEnsemblesAction {
  let params = { limit };

  if (cursor) {
    params = {
      ...params,
      cursor,
    };
  }

  if (name) {
    params = {
      ...params,
      name,
    };
  }

  const cacheId = 'query-' + name;

  return {
    type: 'FETCH_ENSEMBLES',
    cacheId,
    IDAGIO_REQUEST: {
      type: 'API_REQUEST',
      method: 'GET',
      endpoint: '/v2.0/metadata/ensembles',
      params,
    },
    meta: {
      schema: EnsembleList,
      normalize: normalizeMetaList,
    },
    cache: {
      fetch: state => state.maps.ensembles[cacheId],
      validate: loadedCursor(cursor),
    },
  };
}
